<template>
    <div class="FinishRegister mx-auto my-2">
        <Nav></Nav>
        <!-- done img -->
        <div>
            <img class=" mx-auto" style="width:100%;" src="../../assets/images/regirsterFinish.jpg" />
        </div>
        <div class="my-4 d-flex flex-column align-items-center">
            <span style="font-weight:bold;">註冊完成</span>
            <span style="font-weight:bold;">您可開始使用Quiz等相關功能</span>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/Nav'

export default {
    name: 'FinishRegister',
    components:{
        Nav,
    },
    data () {
        return {
        }
    },
    methods:{
    },
}
</script>




// WEBPACK FOOTER //
// src/components/line/FinishRegister.vue